module.exports = __webpack_public_path__ + "static/media/active_support.dc9368a5.svg";